import { render, staticRenderFns } from "./MatterCautionList.vue?vue&type=template&id=026d7510&"
import script from "./MatterCautionList.vue?vue&type=script&lang=js&"
export * from "./MatterCautionList.vue?vue&type=script&lang=js&"
import style0 from "./MatterCautionList.vue?vue&type=style&index=0&id=026d7510&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports